<template>
  <!-- 添加修改手机号 -->
  <div class="changepwd">
    <div class="cursor-poiner" style="padding:20px;text-decoration:underline;color:blue;" @click="$router.back(-1)">&lt; 返回</div>
    <el-form :rules="rules" ref="newForm" :model="newForm" label-width="120px">
      <!-- <el-form-item label="当前手机号：">
        <span>{{formData.email}}</span>
      </el-form-item>-->
      <el-form-item label="手机号：" prop="mobile">
        <el-input v-model="newForm.mobile" type="text" clearable placeholder="请输入新的手机号码"></el-input>
      </el-form-item>
      <el-form-item label="验证码：" prop="code">
        <el-row :gutter="30">
          <el-col :span="10" class="tal">
            <el-input v-model="newForm.code" placeholder="请输入验证码"></el-input>
          </el-col>
          <el-col :span="8" class>
            <el-button :disabled="isDisable" @click="getCode">{{codeName}}</el-button>
          </el-col>
        </el-row>
      </el-form-item>
      <!-- <el-form-item prop="newEmail" label="新邮箱：">
        <el-input v-model="newForm.newEmail"></el-input>
      </el-form-item>
      <el-form-item prop="code" label="邮箱验证码：">
        <el-row :gutter="30">
          <el-col :span="10" class="tal">
            <el-input v-model="newForm.code"></el-input>
          </el-col>
          <el-col :span="8" class>
            <el-button @click="getCode">{{codeName}}</el-button>
          </el-col>
        </el-row>
      </el-form-item>-->
      <el-form-item>
        <el-button @click="submit('newForm')">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import qs from "qs";
export default {
  data: function() {
    // 手机号格式
    var mobilePass = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入手机号"));
      } else {
        var part = /^\d{11}$/;
        if (part.test(value)) {
          callback();
        } else {
          callback(new Error("手机号格式错误"));
        }
      }
    };
    return {
      newForm: {
        mobile: "", // 新邮箱
        code: "" // 验证码
      },
      rules: {
        mobile: [
          { validator: mobilePass, trigger: "blur" },
          { required: true, message: "请输入手机号", trigger: "blur" }
        ],
        code: [{ required: true, message: "请输入手机验证码", trigger: "blur" }]
      },
      formData: {},
      num: "60",
      codeName: "获取验证码",
      isDisable: false
    };
  },
  methods: {
    setTime() {
      if (this.num == 0) {
        this.codeName = "获取验证码";
        this.isDisable = false;
      } else {
        this.codeName = "重新获取(" + this.num + "s)";
        this.isDisable = true;
        this.num--;
        // console.log(this.num);
      }
      setTimeout(() => {
        this.setTime();
      }, 1000);
    },
    //
    getInfo: function() {
      this.formData = this.$store.state.userInfo;
      console.log(this.$store.state.userInfo);
    },
    getCode: async function() {
      var res = await this.$http.get(`/v1/captcha/sendSmsCode?mobile=${this.newForm.mobile}`)
      var {code,message,data } = res.data
      if(code == 0){
        this.$message.success('验证码发送至手机！')
        this.setTime();
      }else{
        this.$message.error(message)
      }
    },
    // 提交
    submit:async function(newForm) {
      this.$refs[newForm].validate(async valid => {
        if (valid) {
          var res = await this.$http.post(
            "/v1/userInfo/updateMobile",
            qs.stringify(this.newForm)
          );
          var { code, message, data } = res.data;
          if (code == 0) {
            this.$messge.success(message);
            this.$router.push("/login");
          }else{
            this.$message.error(message)
          }
        } else {
          this.$message.error("参数不合法！");
        }
      });
    }
  },
  mounted: function() {
    this.getInfo();
  },
  beforeDestroy: function() {
    this.formData = {};
    this.$store.state.userInfo = {};
  }
};
</script>

<style lang="scss" scoped>
.changepwd .el-row .el-col {
  padding: 0 !important;
}
.el-input {
  width: 300px;
}
</style>


// WEBPACK FOOTER //
// src/components/personalcenter/common/changephone.vue